// extracted by mini-css-extract-plugin
export var buttonContainer = "_8t-1";
export var fontSizeSelect = "_8t-3";
export var formatSelect = "_8t-2";
export var formats = "_8t-4";
export var hidden = "_8t-5";
export var icon = "_8t-6";
export var select = "_8t-0";